"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _auth = require("@/utils/auth");
var _store = _interopRequireDefault(require("@/store"));
var _member_label = require("@/api/member/member_label.js");
var _popupConfig = require("@/api/popup/popupConfig.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MemberLabelFormPane',
  components: {},
  props: {
    imgAccessDomain: {
      type: String,
      required: true
    },
    fnId: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      uploadIconUrl: process.env.VUE_APP_PIM_API + 'xyMemberLabel/uploadIcon',
      uploadBgUrl: process.env.VUE_APP_PIM_API + 'xyMemberLabel/uploadBg',
      form: {
        labelName: '',
        discount: 100,
        notice: '',
        imgUrl: '',
        bgUrl: '',
        syncCdpGroup: false,
        // 是否同步CDP分组，0:否 1:是
        cdpGrpType: 0,
        // CDP分组类型 1:分组 2:消费行为
        cdpGroupId: '' // CDP分组ID
      },
      // CDP分组下拉框相关数据
      cdpGroupOptions: [],
      cdpGroupLoading: false
    };
  },
  computed: {
    // 计算属性的 getter
    headers: function headers() {
      return {
        'X-Token': _store.default.getters.token || (0, _auth.getToken)()
      };
    }
  },
  created: function created() {
    if (this.fnId) {
      this.getMemberLabel();
    }
  },
  methods: {
    closeDrawer: function closeDrawer() {
      this.$emit('close');
    },
    getMemberLabel: function getMemberLabel() {
      var _this = this;
      (0, _member_label.queryMemberLabel)(this.fnId).then(function (res) {
        var data = res.data;
        if (data) {
          _this.form.labelName = data.labelName;
          _this.form.discount = data.discount;
          _this.form.notice = data.notice;
          _this.form.imgUrl = data.imgUrl;
          _this.form.bgUrl = data.bgUrl;
          // 设置CDP分组相关字段的默认值，确保数据类型正确
          _this.form.syncCdpGroup = Boolean(data.syncCdpGroup) || false;
          _this.form.cdpGroupId = String(data.cdpGroupId || '');
          _this.form.cdpGrpType = data.cdpGrpType || 0; // CDP分组类型 0默认 1:分组 2:消费行为
        }
        if (data.cdpGrpType != 0 && data.cdpGroupId && data.syncCdpGroup) {
          _this.queryCdpGroupList('');
        }
      });
    },
    saveOrUpdateUserLevel: function saveOrUpdateUserLevel() {
      var _this2 = this;
      if (this.fnId) {
        var data = _objectSpread({
          fnId: this.fnId
        }, this.form);
        (0, _member_label.updateMemberLabel)(data).then(function () {
          _this2.dialogVisible = false;
          _this2.$message({
            message: '更新成功',
            type: 'success'
          });
          _this2.$emit('success');
        });
      } else {
        (0, _member_label.addMemberLabel)(this.form).then(function () {
          _this2.dialogVisible = false;
          _this2.$message({
            message: '添加成功',
            type: 'success'
          });
          _this2.$emit('success');
        });
      }
    },
    handleBgSuccess: function handleBgSuccess(res, file) {
      if (res.code === 200) {
        this.form.bgUrl = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    beforeUploadBg: function beforeUploadBg(file) {
      var isJPGorPNG = file.type === 'image/jpeg' || file.type === 'image/png';
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPGorPNG) {
        this.$message.error('上传图片格式为jpg/png!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不超过2M!');
      }
      return isJPGorPNG && isLt2M;
    },
    handleIconSuccess: function handleIconSuccess(res, file) {
      if (res.code === 200) {
        this.form.imgUrl = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    beforeUploadIcon: function beforeUploadIcon(file) {
      var isJPGorPNG = file.type === 'image/jpeg' || file.type === 'image/png';
      var isLt500K = file.size / 1024 < 500;
      if (!isJPGorPNG) {
        this.$message.error('上传图片格式为jpg/png!');
      }
      if (!isLt500K) {
        this.$message.error('上传图片大小不超过500kb!');
      }
      return isJPGorPNG && isLt500K;
    },
    // 处理CDP分组类型变化
    handleCdpGrpTypeChange: function handleCdpGrpTypeChange(value) {
      // 清空之前选择的分组
      this.form.cdpGroupId = null;
      this.cdpGroupOptions = [];

      // 如果选择了分组类型，则查询对应的分组列表
      if (value !== 0) {
        this.queryCdpGroupList('');
      }
    },
    // 查询CDP分组或消费行为信息
    queryCdpGroupList: function queryCdpGroupList(query) {
      var _this3 = this;
      // 如果没有选择分组类型，直接返回
      if (this.form.cdpGrpType === 0) {
        this.cdpGroupOptions = [];
        return;
      }
      this.cdpGroupLoading = true;
      (0, _popupConfig.queryCdpGroupList)({
        type: this.form.cdpGrpType,
        name: query
      }).then(function (response) {
        if (response.code === 200) {
          _this3.cdpGroupOptions = response.data.map(function (item) {
            return {
              value: String(item.id),
              label: item.name
            };
          });
        } else {
          _this3.$message.error('查询分组列表失败: ' + (response.message || '未知错误'));
        }
      }).catch(function (error) {
        console.error('查询分组列表错误:', error);
        _this3.$message.error('查询分组列表失败: ' + (error.message || '网络错误'));
      }).finally(function () {
        _this3.cdpGroupLoading = false;
      });
    }
  }
};